export const isLegacyFormat = (data) => Array.isArray(data);

export const transformToObjectFormat = (data) => {
  if (!data) return { default: [], support: [] };
  if (isLegacyFormat(data)) {
    return { default: [...data], support: [] };
  }
  return data;
};

export const getAllCodeGroupIds = (data) => {
  if (!data) return [];
  if (isLegacyFormat(data)) return data;
  return [...(data.default || []), ...(data.support || [])];
};

export const categorizeCodeGroups = (codeGroupList) => {
  const result = { default: [], support: [] };
  codeGroupList.forEach((codeGroup) => {
    const category = codeGroup?.category;
    if (category === "SUPPORT") {
      result.support.push(codeGroup.codeGroupId);
    } else {
      result.default.push(codeGroup.codeGroupId);
    }
  });
  return result;
};
